<!--
soho-busyindicator needed here for paging.
-->
<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [timeToComplete]="this.uiLoadingIndicatorTimeout"
  (complete)="onBusyIndicatorComplete($event)"
  [transparentOverlay]="true"
  >
  <!-- USE FLEX LAYOUT -->
  <div class="scrollable-flex" [style.height]="'100%'">
    <div class="scrollable-flex-content" [ngClass]="listGridScrollableContentClasses">
      @if (gridOptions) {
        <lm-list-datagrid-wrapper #DatagridWrapper
          [dataGridId]="dataGridId"
          [dataGridAutomationId]="dataGridAutomationId"
          [gridOptions]="gridOptions"
          [emptyMessage]="emptyMessage"
          [htmlClasses]="showEmptyMessageOnList"
          (cellchange)="onCellChange($event)"
          (rowAdd)="onRowAdd($event)"
          (closeFilterRow)="onCloseFilterRow($event)"
          (openFilterRow)="onOpenFilterRow($event)"
          (contextMenu)="onContextMenu($event)"
          (entereditmode)="onEnterEditMode($event)"
          (filtered)="onFilterPage($event)"
          (keydown)="onKeyDown($event)"
          (rendered)="onRendered($event)"
          (rowActivated)="onRowActivated($event)"
          (rowDeactivated)="onRowDeactivated($event)"
          (rowClicked)="onRowClicked($event)"
          (rowDoubleClicked)="onRowDoubleClicked($event)"
          (selected)="onRowSelected($event)"
          (settingsChanged)="onSettingsChanged($event)"
          (sorted)="onSortPage($event)"
          (filteroperatorchanged)="onFilterOperatorChanged($event)"
        ></lm-list-datagrid-wrapper>
      }
    </div>

    <!-- FLEX FOOTER -->
    @if (!hidePagerBar) {
      <lm-list-pager-wrapper
        class="scrollable-flex-footer"
        id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
        [attr.data-automation-id]="pagerAutomationId"
        [attributes]="pagerIdAttributes"
        [smallPageSizeSelector]="true"
        [pageSizeMenuSettings]="{ attachToBody: true }"
        [showPageSizeSelector]="showPageSizeChooser"
        [enableFirstButton]="enableFirstPage"
        [enablePreviousButton]="enablePreviousPage"
        [enableNextButton]="enableNextPage"
        [enableLastButton]="enableLastPage"
        [firstPageTooltip]="firstPageButtonTooltip"
        [previousPageTooltip]="previousPageButtonTooltip"
        [nextPageTooltip]="nextPageButtonTooltip"
        [lastPageTooltip]="lastPageButtonTooltip"
        [pageSize]="pageSize"
        [pageSizes]="pageSizes"
        (firstPage)="onFirstPage($event)"
        (previousPage)="onPreviousPage($event)"
        (nextPage)="onNextPage($event)"
        (lastPage)="onLastPage($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      ></lm-list-pager-wrapper>
    }
  </div>
  <div class="audible">
    <p aria-hidden="true" aria-live="polite">{{searchResultText}}</p>
  </div>
</div>
